import { IUserAddress } from './user-address';
import { IUserPhone } from './user-phone';
import { IEmergencyContacts } from './emergency-contacts';


export enum ResidentStatus {
    not_active = 'not_active',
    invited = 'invited',
    active = 'active'
}

export interface IUser {
    id?: number;
    username: string;
    email: string;
    fullName: string;
    dateOfBirth: string;
    addresses: IUserAddress[];
    phones: IUserPhone[];
    emergencyContact: string;
    emergencyContacts: IEmergencyContacts[];
    emergencyAssistantNotes: string;
    note: string;
    residentStatus: ResidentStatus;
    photo: string;
    groups: any;
}

export class User implements IUser {
    id = undefined;
    addresses: IUserAddress[] = [];
    dateOfBirth: string;
    email: string;
    emergencyAssistantNotes: string;
    emergencyContact: string;
    emergencyContacts: IEmergencyContacts[] = [];
    fullName: string;
    note: string;
    phones: IUserPhone[] = [];
    photo: string;
    residentStatus = ResidentStatus.active;
    username: string;
    groups = [];
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/building/user.ts